import { MinzeElement } from 'minze'
export interface LvcSearchCrossIcon {}
export class LvcSearchCrossIcon extends MinzeElement {
  html = () => `
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="16" height="16" rx="8" fill="#BFF0FF"/>
      <path d="M11.3681 12.2895C10.1384 11.2555 8.95441 10.167 7.81984 9.02781M7.81984 9.02781C6.71741 7.92086 5.63669 6.75178 4.63123 5.55261M7.81984 9.02781C8.86249 7.78528 10.0988 6.7481 11.3681 5.55261M7.81984 9.02781C6.62169 10.3019 5.74375 11.049 4.63123 12.2895" stroke="#1E007D" stroke-width="1.49211" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `
  css = () => `
    
  `
}
